<template>
  <div
    class="add-to-cart"
    data-ui="benefits-add-to-cart"
  >
    <cdr-img
      src="https://www.rei.com/dam/21294324_member-benefit-badge-100-percent-satisfaction-guarantee.png"
      alt="100% Satisfaction Guarantee"
      class="add-to-cart__image"
      loading="lazy"
    />
    <cdr-text
      class="add-to-cart__heading"
      tag="h2"
    >
      Members get 1 full year for returns
    </cdr-text>
    <cdr-text
      class="add-to-cart__body"
      tag="p"
    >
      Don’t love it? Bring it back. Our 100% Satisfaction Guarantee has you covered.
      With a few exceptions, members get 1 full year for replacements or refunds.
      <br>
      Exclusions apply.
    </cdr-text>
    <add-membership-to-cart
      v-if="!user.isMember"
      data-ui="benefits-add-to-cart-button"
      :cta-text="homePageInjectables.addMembershipToCart"
      :is-added-to-cart="membershipInCart"
      data-analytics-config="exclude"
      @click="handleClick"
      @error="handleError"
      @success="handleSuccess"
      @warn="handleWarn"
    />
  </div>
</template>

<script>
import { CdrImg, CdrText } from '@rei/cedar';
import AddMembershipToCart from '@rei/add-membership-to-cart';
import { metricsLinkAddToCart } from '../../../utils/analytics';

export default {
  name: 'BenefitsAddToCart',
  components: {
    AddMembershipToCart,
    CdrText,
    CdrImg,
  },
  inject: ['userInformation', 'homePageInjectables'],
  props: {
    body: {
      type: String,
      required: false,
      default: '',
    },
    buttonEyebrow: {
      type: String,
      required: false,
      default: '',
    },
    membershipInCart: {
      type: Boolean,
      required: true,
    },
  },
  /* c8 ignore start */
  emits: ['error', 'success', 'warn'],
  /* c8 ignore end */
  computed: {
    user() {
      return this.userInformation.user;
    },
  },
  methods: {
    /* c8 ignore start */
    handleClick() {
      metricsLinkAddToCart(`add-membership_${this.homePageInjectables.addMembershipToCart}`);
    },
    handleError(message) {
      this.$emit('error', message);
    },
    handleSuccess() {
      this.$emit('success');
    },
    handleWarn(message) {
      this.$emit('warn', message);
    },
    /* c8 ignore end */
  },
};
</script>

<style lang="scss">

.add-to-cart {
  text-align: center;
  margin-bottom: $cdr-space-three-x;
  @include cdr-lg-mq-up {
    margin-bottom: 8rem;
  }
}

.add-to-cart .add-membership__button {
  width: 100%;
  justify-content: center;
  max-width: 340px;
}

.add-to-cart__image {
  max-width: 142px;
  margin-bottom: $cdr-space-half-x;
}

.add-to-cart__heading {
  @include cdr-text-heading-serif-600;
  margin-bottom: $cdr-space-three-quarter-x;
  text-wrap: initial;
  padding: 0 $cdr-space-two-x;
  @include cdr-lg-mq-up {
    @include cdr-text-heading-serif-800;
    margin-bottom: $cdr-space-one-x;
  }
}
.add-to-cart__body {
  @include cdr-text-body-300;
  margin: auto;
  margin-bottom: $cdr-space-half-x;
  padding: 0 1.6rem;
  max-width: 750px;

  @include cdr-lg-mq-up {
    margin-bottom: $cdr-space-one-x;
    br {
      display: none;
    }
  }
}
</style>
